import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import styles from 'components/ClientMenuIconStyles.module.scss';
import Menu from 'components/Menu';

export default class ClientMenuIcon extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    toggleMenu = () => {
        const opening = !this.state.open;
        this.setState({ open: opening });
        if (opening && this.props.showHints) {
            this.props.onHelpClick();
        }
    }

    toggleHelp = () => {
        if (this.state.open) {
            this.setState({ open: false });
        }
        this.props.onHelpClick();
    }

    render() {
        return (
            <div className={`${styles.clientMenuContainer}`}>
                <div className={styles.iconRow}>
                    <FontAwesomeIcon
                        icon={faCog}
                        className={`${styles.clientMenuIcon}`}
                        onClick={this.toggleMenu}
                    />
                    <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className={`${styles.clientMenuIcon} ${styles.helpIcon}`}
                        onClick={this.toggleHelp}
                    />
                </div>
                <Menu room={this.props.room} toggleMenu={this.toggleMenu} menuOpen={this.state.open} gameState={this.props.gameState} />
             </div>
        )
    }

}
